// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + "aee8fafcc3b7e7f26bed" + "";
};